/* eslint-disable no-unused-vars */
// import axios from 'axios'
import axios from '../../helpers/Axios'
import router from '../../router'

export const companysearchmodule = {

	namespaced: true,

	state: {
		saving: false,
		search: {
			includedKeywords: [],
			excludedKeywords: [],
			sectors: [],
			sicCodes: [],
			resultCount: 0,
			resultStatus: 0,
			includeCompanyNames: [],
			files: [],
			includeCompanyNumbers: [],
			includeVendorReferences: [],
			excludeCompanyNumbers: [],
			excludeSubsidiariesAndIntermediates: false,
			excludeFiles: [],
			recalculatingCount: false,
			excludePLCs: false,
			excludePrivateInvestors: false,
			excludePrivateEquityHouses: false,
			loadingResults: false,
			excludeBlocked: true,
			bqProfileIncludeKeywords: [],
			bqProfileKeywordIncludeAll: false,
			excludeDoNotSend: true,
		},
		searchError: {},
		searchCount: 0,
		sectionsVisible: {
			companySearch: true,
			industry: true,
			financials: true,
			buyerTraits: true,
			numbers: true,
			bqprofile: true
		},
		savePagePromise: null,
		resultCountPromise: null,
		dataLoaded: false,
		isInfoBoxVisible: false,
		infoBoxHeader: '',
		infoBoxBody: '',
		status: { savingField: false, updatingCount: false },
		requireReCount: false,
		requireReSave: false
	},
	getters: {
		search: state => {
			return state.search;
		},
		searchError: state => {
			return state.searchError;
		},
		saving: state => {
			return state.saving;
		},
		searchCount: state => {
			return state.searchCount;
		},
		requireReCount: state => {
			return state.requireReCount;
		},
		requireReSave: state => {
			return state.requireReSave;
		}
	},
	actions: {

		getCompanySearch({ commit, state, dispatch }) {

			const config = { headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', Pragma: 'no-cache' } };

			return axios.get('/companysearch/load-search/' + state.search.companySearchId, config).then(response => {
				let loadedSearchData = response.data.search;
				loadedSearchData.recalculatingCount = false;
				loadedSearchData.resultCount = 0;
				loadedSearchData.resultStatus = 0;
				dispatch('requestCompanyResultCount');
				commit('updateSearch', loadedSearchData);
			}).catch(err => {
				console.log(err);
				global.location.replace('/error/error404');
			});
		},
		resetSearch({ commit, state }){
			var search = state.search;
			search.resultStatus = 0;
			commit('updateSearch', search);
		},

		requestCompanySave({ commit, dispatch, state }) {

			return new Promise((resolve, reject) => {
				if (!state.saving) {
					dispatch('saveCompanySearch', true).then(() => resolve(true));
				} else {
					commit('updateRequireReSave', true);
					resolve(false);
				}
			});
		},

		requestCompanySaveNoCount({ commit, dispatch, state }) {


			console.log('requestCompanySaveNoCount');

/* eslint-disable no-unused-vars */
			return new Promise((resolve, reject) => {
				if (!state.saving) {

					dispatch('saveCompanySearch', true).then(() => 
					{
						console.log('/Search/search');
						axios.post('/Search/search', state.search).then(response => {
							console.log('resolve true');
							console.log(state.search);
						resolve(true);
						});
					}
					
					);
					
				} else {
					commit('updateRequireReSave', true);
					console.log('resolve false');
					resolve(false);
				}
			});
		},

		saveCompanySearch({ commit, state, dispatch }, doCount) {

			console.log('saveCompanySearch', doCount);

			return new Promise((resolve, reject) => {

				commit('updateSave', true);
				commit('updateRequireReSave', false);
				commit('updateSearchError', {});

				console.log('/search/update');
				axios.post('/search/update', state.search).then(response => {
					var currentState = state.search;

					currentState.companySearchId = response.data.companySearchId;

					commit('updateSearch', currentState);
					commit('updateInfoBox', { isVisible: false, header: '', body: '' });
					commit('updateSave', false);

					if (state.requireReSave) {

						console.log('requireReSave');
						dispatch('saveCompanySearch', doCount)
							.then(() => resolve(true));
					} else {
						if (doCount) dispatch('requestCompanyResultCount');
						resolve(true);
					}

				}).catch(err => {
					console.log(err);
					commit('updateSearchError', err.data);
					commit('updateInfoBox', { isVisible: true, header: 'Validation Error', body: 'Fix validation errors to continue' });
					commit('updateSave', false);

					if (state.requireReSave) {
						dispatch('saveCompanySearch', doCount)
							.then(() => resolve(true));
					} else {
						if (doCount) dispatch('requestCompanyResultCount');
						reject(err);
					}
				});
			});
		},
		searchCompanyIndex({commit, dispatch, state}){
			axios.post('/Search/search', state.search)
		},
		requestCompanyResultCount({ commit, dispatch, state }) {

			if (!state.search.recalculatingCount) {
				dispatch('getCompanyResultCount');
			} else {
				commit('updateRequireReCount', true);
			}
		},
		requestExcludeSearch({commit, dispatch, state}){
			
			return new Promise((resolve, reject) => {
				console.log('/Search/search');
				axios.post('/Search/search', state.search).then(() => resolve(true))
				.catch(err => {
					resolve(false);
				});
			});


		},
		getCompanyResultCount({ commit, dispatch, state }) {

			commit('recalculatingCount', true);
			commit('updateRequireReCount', false);

			const config = { headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', Pragma: 'no-cache' } };

			axios.post('/search/gethits' , state.search).then(response => {
				var currentState = state.search;
				commit('upddateSearchCount', response.data);
				currentState.resultCount = response.data;
				if (response.data > 5000) currentState.resultStatus = 2;
				else if (response.data > 3000) currentState.resultStatus = 3;
				else currentState.resultStatus = 0;
				// currentState.resultStatus = response.data.status;
				currentState.recalculatingCount = false;
				commit('updateSearch', currentState);
				commit('recalculatingCount', false);
				//
				// if (state.requireReCount) {
				//
				// 	dispatch('requestCompanyResultCount');
				// }
			}).catch(err => {
				console.log(err);
				commit('recalculatingCount', false);
				// if (state.requireReCount) {
				//
				// 	dispatch('requestCompanyResultCount');
				// }
			});
		},

		addIncludedKeyword({ commit, state }) {
			var search = state.search;
			search.includedKeywords.push({ keyword: '', searchName: false, mustInclude: false });
			commit('updateSearch', search);
		},

		removeIncludedKeyword({ commit, state, dispatch }, ref) {
			var search = state.search;
			search.includedKeywords.splice(ref, 1);
			commit('updateSearch', search);
			dispatch('saveCompanySearch').then(() => {
				dispatch('requestCompanyResultCount');
			});
		},

		addBQProfileIncludedKeyword({ commit, state }) {
			var search = state.search;
			search.bqProfileIncludeKeywords.push({ keyword: '', mustInclude: false });
			commit('updateSearch', search);
		},

		removeBQProfileIncludedKeyword({ commit, state, dispatch }, ref) {
			var search = state.search;
			search.bqProfileIncludeKeywords.splice(ref, 1);
			commit('updateSearch', search);
			dispatch('saveCompanySearch').then(() => {
				dispatch('requestCompanyResultCount');
			});
		},

		addExcludedKeyword({ commit, state }) {
			var search = state.search;
			search.excludedKeywords.push({ keyword: '' });
			commit('updateSearch', search);
		},

		removeExcludedKeyword({ commit, state, dispatch }, ref) {
			var search = state.search;
			search.excludedKeywords.splice(ref, 1);
			commit('updateSearch', search);
			dispatch('saveCompanySearch').then(() => {
				dispatch('requestCompanyResultCount');
			});
		},
		postCompanyIndexSearch({comit, state, dispatch}){

		},
		showResults({ commit, state,  }) {
			console.log('showResults');
			state.loadingResults = true;
			commit('loadingResults', true);
			console.log('/Search/search');
			axios.post('/Search/search', state.search).then(response => {
				return axios.post('/companysearch/show-results', state.search).then(response => {
					let companySearchId = response.data
					router.push('/results/' + companySearchId);
				}).catch(err => {
					commit('updateSearchError', err.data);
					commit('updateInfoBox', { isVisible: true, header: 'Validation Error', body: 'Fix validation errors to continue' });
					commit('loadingResults', false);
				});
			}).catch(err => {
				commit('updateSearchError', err.data);
					commit('updateInfoBox', { isVisible: true, header: 'Search Error', body: 'There was an error while preparing results' });
					commit('loadingResults', false);
			});
		},

		addSector({ commit, state }) {
			var search = state.search;
			search.sectors.push({ sectorId: '', subSectorId: null, include: 1 });

			commit('updateSearch', search);
		},

		removeSector({ commit, state, dispatch }, ref) {
			var search = state.search;
			search.sectors.splice(ref, 1);
			commit('updateSearch', search);
			dispatch('saveCompanySearch').then(() => {
				dispatch('requestCompanyResultCount');
			});
		},

		addSicCode({ commit, state }) {
			var search = state.search;
			search.sicCodes.push({ sicCodeId: '', include: true });
			commit('updateSearch', search);
		},

		removeSicCode({ commit, state, dispatch }, ref) {
			var search = state.search;
			search.sicCodes.splice(ref, 1);
			commit('updateSearch', search);
			dispatch('saveCompanySearch').then(() => {
				dispatch('requestCompanyResultCount');
			});
		}


	},
	mutations: {

		updateSearch(state, search) {
			
			state.search = search;
			state.dataLoaded = true;
		},
		updateSearchError(state, error) {
			state.searchError = error
		},
		updateSave(state, save) {
			state.saving = save;
			state.status.savingField = save;
		},
		updateSectionsVisible(state, sectionsVisible) {
			state.sectionsVisible = sectionsVisible
		},
		updateSavePagePromise(state, savePagePromise) {
			state.savePagePromise = savePagePromise
		},
		updateResultCountPromise(state, resultCountPromise) {
			state.resultCountPromise = resultCountPromise
		},
		updateIsInfoBoxVisible(state, isInfoBoxVisible) {
			state.isInfoBoxVisible = isInfoBoxVisible
		},
		updateInfoBox(state, payload) {
			state.isInfoBoxVisible = payload.isVisible;
			state.infoBoxHeader = payload.header;
			state.infoBoxBody = payload.body;
		},
		recalculatingCount(state, recalculatingCount) {
			
			state.search.recalculatingCount = recalculatingCount;
			state.status.updatingCount = recalculatingCount;
		},
		loadingResults(state, isLoadingResults) {
			
			state.search.loadingResults = isLoadingResults;
			state.status.loadingResults = isLoadingResults;
		},
		
		updateRequireReCount(state, requireReCount) {
			state.requireReCount = requireReCount;
		},
		updateRequireReSave(state, requireReSave) {
			state.requireReSave = requireReSave;
		},
		upddateSearchCount(state, count){
			state.searchCount = count;
		},
	}

}
